'use strict';

exports.__esModule = true;

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _lodashOmit = require('lodash.omit');

var _lodashOmit2 = _interopRequireDefault(_lodashOmit);

var _tcombReact = require('tcomb-react');

var _browserCookieLite = require('browser-cookie-lite');

var _BannerContent = require('./BannerContent');

var _BannerContent2 = _interopRequireDefault(_BannerContent);

_tcombReact.t['interface'].strict = true;

var Props = _extends({}, _BannerContent.Props, {
  children: _tcombReact.t.maybe(_tcombReact.t.union([_tcombReact.t.ReactChildren, _tcombReact.t.Function])),
  onAccept: _tcombReact.t.maybe(_tcombReact.t.Function),
  cookie: _tcombReact.t.maybe(_tcombReact.t.String),
  cookieExpiration: _tcombReact.t.maybe(_tcombReact.t.union([_tcombReact.t.Integer, _tcombReact.t['interface']({
    years: _tcombReact.t.maybe(_tcombReact.t.Number),
    days: _tcombReact.t.maybe(_tcombReact.t.Number),
    hours: _tcombReact.t.maybe(_tcombReact.t.Number)
  })])),
  cookiePath: _tcombReact.t.maybe(_tcombReact.t.String),
  dismissOnScroll: _tcombReact.t.maybe(_tcombReact.t.Boolean),
  dismissOnScrollThreshold: _tcombReact.t.maybe(_tcombReact.t.Number)
});

/** React Cookie banner dismissable with just a scroll!
 * @param children - custom component rendered if user has not accepted cookies
 * @param message - message written inside default cookie banner
 * @param onAccept - called when user accepts cookies
 * @param link - object with infos used to render a link to your cookie-policy page
 * @param buttonMessage - message written inside the button of the default cookie banner
 * @param cookie - cookie-key used to save user's decision about you cookie-policy
 * @param cookieExpiration - used to set the cookie expiration
 * @param cookiePath - used to set the cookie path
 * @param dismissOnScroll - whether the cookie banner should be dismissed on scroll or not
 * @param dismissOnScrollThreshold -
 *   amount of pixel the user need to scroll to dismiss the cookie banner
 * @param closeIcon - className passed to close-icon
 * @param disableStyle - pass `true` if you want to disable default style
 * @param styles - object with custom styles used to overwrite default ones
 */

var CookieBanner = (function (_React$Component) {
  _inherits(CookieBanner, _React$Component);

  function CookieBanner() {
    var _this = this;

    _classCallCheck(this, _CookieBanner);

    _React$Component.apply(this, arguments);

    this.state = { listeningScroll: false };

    this.addOnScrollListener = function (props) {
      var _props = props || _this.props;
      if (!_this.state.listeningScroll && !_this.hasAcceptedCookies() && _props.dismissOnScroll) {
        if (window.attachEvent) {
          // Internet Explorer
          window.attachEvent('onscroll', _this.onScroll);
        } else if (window.addEventListener) {
          window.addEventListener('scroll', _this.onScroll, false);
        }
        _this.setState({ listeningScroll: true });
      }
    };

    this.removeOnScrollListener = function () {
      if (_this.state.listeningScroll) {
        if (window.detachEvent) {
          // Internet Explorer
          window.detachEvent('onscroll', _this.onScroll);
        } else if (window.removeEventListener) {
          window.removeEventListener('scroll', _this.onScroll, false);
        }
        _this.setState({ listeningScroll: false });
      }
    };

    this.onScroll = function () {
      // tacit agreement buahaha! (evil laugh)
      if (window.pageYOffset > _this.props.dismissOnScrollThreshold) {
        _this.onAccept();
      }
    };

    this.getSecondsSinceExpiration = function (cookieExpiration) {
      if (_tcombReact.t.Integer.is(cookieExpiration)) {
        return cookieExpiration;
      }

      var SECONDS_IN_YEAR = 31536000;
      var SECONDS_IN_DAY = 86400;
      var SECONDS_IN_HOUR = 3600;

      var _cookieExpiration = _extends({
        years: 0, days: 0, hours: 0
      }, cookieExpiration);

      var years = _cookieExpiration.years;
      var days = _cookieExpiration.days;
      var hours = _cookieExpiration.hours;

      return years * SECONDS_IN_YEAR + days * SECONDS_IN_DAY + hours * SECONDS_IN_HOUR;
    };

    this.onAccept = function () {
      var _props2 = _this.props;
      var cookie = _props2.cookie;
      var cookieExpiration = _props2.cookieExpiration;
      var cookiePath = _props2.cookiePath;
      var onAccept = _props2.onAccept;

      _browserCookieLite.cookie(cookie, true, _this.getSecondsSinceExpiration(cookieExpiration), cookiePath);
      onAccept({ cookie: cookie });

      if (_this.state.listeningScroll) {
        _this.removeOnScrollListener();
      } else {
        _this.forceUpdate();
      }
    };

    this.hasAcceptedCookies = function () {
      return typeof window !== 'undefined' && _browserCookieLite.cookie(_this.props.cookie);
    };
  }

  CookieBanner.prototype.componentDidMount = function componentDidMount() {
    this.addOnScrollListener();
  };

  CookieBanner.prototype.getLocals = function getLocals() {
    var onAccept = this.onAccept;
    var _props3 = this.props;
    var message = _props3.message;
    var link = _props3.link;
    var buttonMessage = _props3.buttonMessage;
    var closeIcon = _props3.closeIcon;
    var disableStyle = _props3.disableStyle;
    var styles = _props3.styles;
    var className = _props3.className;
    var children = _props3.children;

    var props = _objectWithoutProperties(_props3, ['message', 'link', 'buttonMessage', 'closeIcon', 'disableStyle', 'styles', 'className', 'children']);

    return {
      children: children,
      onAccept: onAccept,
      hasAcceptedCookies: this.hasAcceptedCookies(),
      bannerContentProps: _extends({}, _lodashOmit2['default'](props, Object.keys(Props)), {
        message: message, onAccept: onAccept, link: link, buttonMessage: buttonMessage,
        closeIcon: closeIcon, disableStyle: disableStyle, styles: styles, className: className
      })
    };
  };

  CookieBanner.prototype.templateChildren = function templateChildren(_ref) {
    var children = _ref.children;
    var onAccept = _ref.onAccept;

    if (_tcombReact.t.Function.is(children)) {
      return children(onAccept);
    }
    return children;
  };

  CookieBanner.prototype.render = function render() {
    var _getLocals = this.getLocals();

    var hasAcceptedCookies = _getLocals.hasAcceptedCookies;
    var children = _getLocals.children;
    var bannerContentProps = _getLocals.bannerContentProps;
    var onAccept = _getLocals.onAccept;

    if (hasAcceptedCookies) {
      return null;
    }

    return children ? this.templateChildren({ children: children, onAccept: onAccept }) : _react2['default'].createElement(_BannerContent2['default'], bannerContentProps);
  };

  CookieBanner.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.dismissOnScroll) {
      this.addOnScrollListener(nextProps);
    } else {
      this.removeOnScrollListener();
    }
  };

  CookieBanner.prototype.componentWillUnmount = function componentWillUnmount() {
    this.removeOnScrollListener();
  };

  _createClass(CookieBanner, null, [{
    key: 'defaultProps',
    value: {
      onAccept: function onAccept() {},
      dismissOnScroll: true,
      cookie: 'accepts-cookies',
      cookieExpiration: { years: 1 },
      buttonMessage: 'Got it',
      dismissOnScrollThreshold: 0,
      styles: {}
    },
    enumerable: true
  }]);

  var _CookieBanner = CookieBanner;
  CookieBanner = _tcombReact.props(Props, { strict: false })(CookieBanner) || CookieBanner;
  return CookieBanner;
})(_react2['default'].Component);

exports['default'] = CookieBanner;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-cookie-banner/lib/CookieBanner.js
 ** module id = 297
 ** module chunks = 0
 **/